// extracted by mini-css-extract-plugin
module.exports = {"tokenContainer":"token-detail_tokenContainer__xU7JJ","item":"token-detail_item__21foi","itemBtn":"token-detail_itemBtn__2Cg-r"};